import React from 'react'

const Html = ({ html }) => {
	const handleClick = () => {
		console.log('HTML content:', html);
	}

	return <div className='html' onClick={handleClick}><span className={`icon t-fa fa-eye`} />查看</div>
}

export default Html